import type { ApiClientV2 } from 'utils/api-client/api-client.utils'
import { HTTPResponse } from 'types/responses'

const BASE_URL = (username: string) => `/shop/${username}/payment_sessions`

export interface PaymentSessionResponse {
  data: {
    signed_id: string
    transactionReference: string
    approvalUrl: string
    cancelUrl: string
    returnUrl: string
  }
}

export const createOrdersV2Api = ({ POST }: ApiClientV2) => ({
  createPaymentSession: (username: string, data: Record<string, any>) =>
    POST<PaymentSessionResponse['data'] & HTTPResponse>(`${BASE_URL(username)}`, data),
})

export type OrdersV2Api = ReturnType<typeof createOrdersV2Api>
